import { FILTER_OPTION_TYPE_SEPARATOR } from "~/modules/dtwin/constants";

/**
 * Return an array of values from a dtwin type option
 * @param dtwinTypeOption
 * @returns
 */
export function getFilterDtwinTypeValuesFromOption(
  dtwinTypeOption: string,
): string[] {
  return dtwinTypeOption.split(FILTER_OPTION_TYPE_SEPARATOR);
}
